import {Component, ViewContainerRef} from "@angular/core";
import {ROUTER_DIRECTIVES} from "@angular/router";
import {ObservableBackendService} from "./service/observableBackend.service";
import {NavigationService} from "./service/navigation.service";
import {LoginService} from "./service/login.service";
import {VehiclesService} from "./service/vehicles.service";
import {BankService} from "./service/bank.service";
import {ContractsService} from "./service/contracts.service";
import {CitiesService} from "./service/cities.service";
import {InfractionsService} from "./service/infractions.service";
import {RolesService} from "./service/roles.service";
import {OperatorsService} from "./service/operators.service";
import {ClientService} from "./service/client.service";
import {IndexComponent} from "./index.component";
import {HomeComponent} from "./home.component";
import {FaDirective} from "angular2-fontawesome/directives";
import {VehicleEditorComponent} from "./vehicles/vehicle.editor.component";
import {ContractEditorComponent} from "./contracts/contract.editor.component";
import {InfractionEditorComponent} from "./infractions/infraction.editor.component";
import {ConfigPanel} from "./config/config.panel.component";
import {UnderConstruction} from "./under.construction.component";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/styles.css";
import "../assets/css/forms.css";
import "ng2-select/components/css/ng2-select.css";
import {ConfigBanksComponent} from "./config/banks/config.banks.component";
import {BankEditorComponent} from "./config/banks/bank.editor.component";
import {ConfigRolesComponent} from "./config/roles/config.roles.component";
import {RolEditorComponent} from "./config/roles/rol.editor.component";
import {ConfigOperatorsComponent} from "./config/operators/config.operators.component";
import {OperatorEditorComponent} from "./config/operators/operator.editor.component";
import {ClientPanel} from "./client/client.panel.component";
import {PayReceiptComponent} from "./client/payReceipt/payReceipt.component";
import {ConfigInfractionTypesComponent} from "./config/infractionTypes/config.infractionTypes.component";
import {InfractionTypeService} from "./service/infractionType.service";
import {InfractionTypeEditorComponent} from "./config/infractionTypes/infractionType.editor.component";
import {ConfigClientDocumentsComponent} from "./config/clientFiles/config.clientDocuments.component";
import {ClientDocumentService} from "./service/clientDocument.service";
import {ConfigMailTemplatesComponent} from "./config/mailConfig/config.mailTemplates.component";
import {MailTemplateService} from "./service/mailTemplate.service";
import {ActionTriggerService} from "./service/actionTrigger.service";
import {MailTemplateEditorComponent} from "./config/mailConfig/mailTemplate.editor.component";
import {MailReceiverTypeService} from "./service/mailReceiverType.service";
import {ConfigStateComponent} from "./config/states/config.state.component";
import {StateEditorComponent} from "./config/states/state.editor.component";
import {KmHistoryService} from "./service/kmHistory.service";
import {PatentPaymentService} from "./service/patentPayment.service";
import {ProcedureService} from "./service/procedure.service";
import {KmHistoryEditorComponent} from "./kmHistory/kmHistory.editor.component";
import {PatentPaymentEditorComponent} from "./patentPayment/patentPayment.editor.component";
import {AgendaService} from "./service/agenda.service";
import {MailTemplatePropertyService} from "./service/mailTemplateProperty.service";
import {MailTemplateTagService} from "./service/mailTemplateTag.service";
import {VehicleBrandService} from "./service/vehicleBrand.service";
import {VehicleBrandEditorComponent} from "./config/vehicleBrands/vehicleBrand.editor.component";
import {ConfigVehicleBrandsComponent} from "./config/vehicleBrands/config.vehicleBrands.component";

import {TabSelectedService} from "./service/tabSelected.service";
import {ConfigClientProcedureDocumentsComponent} from "./config/clientProcedureFiles/config.clientProcedureDocuments.component";
import {ConfigClientKmDocumentsComponent} from "./config/clientKmFiles/config.clientKmDocuments.component";
import {ConfigClientPatentDocumentsComponent} from "./config/clientPatentFiles/config.clientPatentDocuments.component";
import {SingleProcedureEditorComponent} from "./procedures/singleProcedures.editor.component";
import {ProcedureEditorComponent} from "./procedures/procedures.editor.component";
import {ProcedureNewComponent} from "./procedures/procedures.new.component";
import {RequestProcedureComponent} from "./client/requestProcedure/requestProcedure.component";

@Component({
    selector: 'my-app',
    template: `
        <div class="container">
            <router-outlet></router-outlet>
        </div>
    `,
    directives: [
        FaDirective,
        ROUTER_DIRECTIVES
    ],
    providers: [
        NavigationService,
        ObservableBackendService,
        LoginService,
        VehiclesService,
        InfractionTypeService,
        BankService,
        ContractsService,
        CitiesService,
        InfractionsService,
        RolesService,
        OperatorsService,
        ClientService,
        ClientDocumentService,
        MailTemplateService,
        ActionTriggerService,
        MailReceiverTypeService,
        KmHistoryService,
        PatentPaymentService,
        ProcedureService,
        AgendaService,
        MailTemplatePropertyService,
        MailTemplateTagService,
        VehicleBrandService,
        TabSelectedService
    ],
    precompile: [
        IndexComponent,
        HomeComponent,
        VehicleEditorComponent,
        ContractEditorComponent,
        InfractionEditorComponent,
        ConfigPanel,
        UnderConstruction,
        ConfigInfractionTypesComponent,
        InfractionTypeEditorComponent,
        ConfigBanksComponent,
        BankEditorComponent,
        ConfigRolesComponent,
        RolEditorComponent,
        ConfigOperatorsComponent,
        OperatorEditorComponent,
        ConfigClientDocumentsComponent,
        ConfigMailTemplatesComponent,
        MailTemplateEditorComponent,
        ClientPanel,
        PayReceiptComponent,
        ConfigStateComponent,
        StateEditorComponent,
        KmHistoryEditorComponent,
        PatentPaymentEditorComponent,
        VehicleBrandEditorComponent,
        ConfigVehicleBrandsComponent,
        ConfigClientProcedureDocumentsComponent,
        ConfigClientKmDocumentsComponent,
        ConfigClientPatentDocumentsComponent,
        SingleProcedureEditorComponent,
        ProcedureEditorComponent,
        ProcedureNewComponent,
        RequestProcedureComponent
    ]
})

export class AppComponent {

    private viewContainerRef: ViewContainerRef;

    public constructor(viewContainerRef: ViewContainerRef) {
        // You need this small hack in order to catch application root view container ref
        this.viewContainerRef = viewContainerRef;
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/app.component.ts
 **/